<template>
  <div>
    <label :for="labelId" class="block text-sm font-medium leading-6 text-gray-900 mb-2" v-if='!props.hideLabel'>{{ props.label }}</label>
    <input type="text" :id="labelId" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-jananavy-600 sm:text-sm sm:leading-6" ref='element' />
  </div>
</template>

<script setup>

import { nanoid } from 'nanoid';

import { computed, onMounted, watch, ref } from 'vue';

import "../../../node_modules/vanillajs-datepicker/dist/css/datepicker.min.css";
import { Datepicker } from 'vanillajs-datepicker';

import enAU from 'vanillajs-datepicker/locales/en-AU';

Object.assign(Datepicker.locales, enAU);

const model = defineModel();

const props = defineProps({
  label: String,
  hideLabel: Boolean,
  labelId: String
});

const labelId = computed(() => {
  return props.labelId || nanoid();
});

let instance = null;
const element = ref();

watch(model, () => {
  modelDidChange();
});

const modelDidChange = () => {
  if (!instance) {
    return;
  }
  
  const date = instance.getDate();
  
  if (date !== model.value) {
    instance.setDate(new Date(model.value));
  }
}

const didChangeDate = () => {
  const date = instance.getDate()?.toISOString() || null;
  
  if (model.value !== date) {
    if (!date) {
      model.value = null;
    } else {
      model.value = date;
    }
  }
}

onMounted(() => {
  if (!instance) {
    instance = new Datepicker(element.value, {
      language: Intl.DateTimeFormat().resolvedOptions().locale,
      clearButton: true,
      autohide: true
    });
    
    if (model.value) {
      instance.setDate(model.value);
    }
    
    element.value.addEventListener('changeDate', () => {
      didChangeDate();
    });
  }
});

</script>